import { useEffect, useState } from "react";
import InputBox from "../../../common/interactive/InputBox";

export default function InputOption({filtersValues, item, mainSelectAction, classes, workQ, isNumber}) {

    const [hideItem, setHideItem] = useState(false)
    useEffect(() => {
        if (workQ && workQ.filter_conditions) {
            if (workQ.filter_conditions[`${item.key}_filter_type`] && workQ.filter_conditions[`${item.key}_filter_type`] == 1) { //we have a rigid filter!!!                
                setHideItem(true)
            }
        }
    }, [workQ, item])
    return <>
        {!hideItem && <div className={classes.row}>
            <InputBox currentValue={filtersValues && filtersValues[item.key]} label={item.label} name={item.key} identifier={{type: item.key}} action={mainSelectAction} format={isNumber ? 'number' : null}/>
        </div>}
    </>
}